import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SpinnerComponent } from '../../../Common/Components/spinner/spinner.component';
import { ApiService } from '../../../Services/api.service';

@Component({
  selector: 'app-webaccount-add-edit',
  standalone: true,
  imports: [NzButtonModule, CommonModule, NzSelectModule, FormsModule, ReactiveFormsModule, SpinnerComponent],
  templateUrl: './webaccount-add-edit.component.html',
  styleUrl: './webaccount-add-edit.component.scss'
})
export class WebaccountAddEditComponent {

  constructor(public apiService: ApiService, private fb: FormBuilder) { }
  webAccountFields = [
    { type: "input", label: "User Id", placeholder: "", value: "", formControlName: "userId", required: true, fieldType: "text" },
    { type: "dropdown", label: "User Type", placeholder: "", value: "Select", formControlName: "userType", required: true },
    { type: "input", label: "New Password", value: "", formControlName: "password", required: true, fieldType: "password" },
    { type: "input", label: "Confirm Password", value: "", formControlName: "confirmPassword", required: true, fieldType: "password" },
    { type: "input", label: "EDP Number", value: "", formControlName: "edpNo", required: true, fieldType: "number" },
    { type: "input", label: "Email ID", value: "", formControlName: "emailId", fieldType: "text" },
    { type: "input", label: "First Name", value: "", formControlName: "firstName", fieldType: "text" },
    { type: "input", label: "Last Name", value: "", formControlName: "lastName", fieldType: "text" },
    { type: "checkbox", label: "Change Password on First Login", value: "", formControlName: "changPasswdFirstLogin" },
    { type: "checkbox", label: "Change Password Allowed", value: "", formControlName: "changePasswdAllowed" },
    { type: "checkbox", label: "AR User", value: "", formControlName: "arUser" },
    { type: "checkbox", label: "Internal User", value: "", formControlName: "internalUser" },
    { type: "checkbox", label: "Allow Notes", value: "", formControlName: "allowNotes" },
  ];
  isLoadingData: boolean = false;
  addEditUserForm: FormGroup = new FormGroup({});
  @Input() userData: any;
  action: string = 'Add';
  @Output() apiStatus = new EventEmitter<any>();
  invalidForm: boolean = false;

  ngOnInit() {
    this.initAddForm();
  }

  addUpdateUserForm() {
    if ((!this.userData) && (!this.addEditUserForm.value.password || !this.addEditUserForm.value.confirmPassword ||
      !this.addEditUserForm.value.userId || !this.addEditUserForm.value.edpNo || !this.addEditUserForm.value.userType
    )) {
      this.invalidForm = true;
      return
    }
    if ((this.userData) && (!this.addEditUserForm.value.userId || !this.addEditUserForm.value.edpNo || !this.addEditUserForm.value.userType )) {
      this.invalidForm = true;
      return
    }
    if((this.userData) && (this.addEditUserForm.value.password && !this.addEditUserForm.value.confirmPassword)){
      this.apiService.createNotification('error', 'Confirm password value is required');
      return
    }
    if ((this.addEditUserForm.value.password && this.userData ) || (!this.userData && this.addEditUserForm.value.password )) {
      if (this.addEditUserForm.value.password.length < 5) {
        this.apiService.createNotification('error', 'Password length should be minimum 5 characters');
        return;
      }
      else if (this.addEditUserForm.value.password != this.addEditUserForm.value.confirmPassword) {
        this.apiService.createNotification('error', 'Passwords do not match');
        return;
      }

    }
     if (this.addEditUserForm.value.emailId) {
      const customEmailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      if(!customEmailRegex.test(this.addEditUserForm.value.emailId)){
      this.apiService.createNotification('error', 'Please enter a valid email address (e.g. yourname@organization.com)');
      return;
      }
    }
    if (this.addEditUserForm.value.edpNo.length != 11) {
      this.apiService.createNotification('error', 'EDPNo should be atleast 11 digits');
      return;
    }
    let postObj = {};
    if (this.userData) {
      postObj = {
        "siteId": 204,
        "userId": this.userData.userId,
        "updateUserId": this.addEditUserForm.value.userId,
        "password": this.addEditUserForm.value.password,
        "edpno": this.addEditUserForm.value.edpNo,
        "emailId": this.addEditUserForm.value.emailId,
        "fname": this.addEditUserForm.value.firstName,
        "lname": this.addEditUserForm.value.lastName,
        "userType": this.addEditUserForm.value.userType,
        "loginInd": this.userData.loginInd,
        "changepass": this.addEditUserForm.value.changePasswdAllowed,
        "arUser": this.addEditUserForm.value.arUser,
        "enablechat": this.userData.enablechat,
        "reportadmin": this.userData.reportAdmin,
        "fadmin": this.userData.fadmin,
        "external": this.userData.external,
        "fviewonly": this.userData.fviewonly,
        "fhideordhistory": this.userData.fhideordhistory,
        "fallownotes": this.addEditUserForm.value.allowNotes,
        "fhideinvlookup": this.userData.fhideinvlookup,
        "fintuser": this.addEditUserForm.value.internalUser
      };
    }
    else {
      postObj = {
        "cuserid": this.addEditUserForm.value.userId,
        "csiteid": 204,
        "xedpno": this.addEditUserForm.value.edpNo,
        "nfailcount": 0,
        "xemailid": this.addEditUserForm.value.emailId,
        "xusertype": this.addEditUserForm.value.userType,
        "xpassword": this.addEditUserForm.value.password,
        "xloginind": "Y",
        "fchangepass": this.addEditUserForm.value.changePasswdAllowed,
        "fviewonly": 0,
        "freportadmin": 0,
        "fhideordhistory": 0,
        "fallownotes": this.addEditUserForm.value.allowNotes,
        "fhideinvlookup": 0,
        "fintuser": this.addEditUserForm.value.internalUser,
        "xlname": this.addEditUserForm.value.lastName,
        "faruser": this.addEditUserForm.value.arUser,
        "xfname": this.addEditUserForm.value.firstName
      }
    }

    this.apiService.addUpdateUser(postObj, this.action).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.userData = [];
      this.apiStatus.emit(true);
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  initAddForm() {
    this.addEditUserForm = this.fb.group({
      userId: ['', Validators.required],
      userType: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      edpNo: ['', Validators.required],
      emailId: [''],
      firstName: [''],
      lastName: [''],
      changPasswdFirstLogin: [0],
      changePasswdAllowed: [1],
      internalUser: [0],
      arUser: [0],
      allowNotes: [0]
    });
    if (this.userData && this.userData.userId) {
      this.webAccountFields[2].required = false;
      this.webAccountFields[3].required = false;
      this.patchForm();
      this.action = 'Edit';
    }
  }

  patchForm() {
    this.addEditUserForm.patchValue({
      userId: this.userData.userId,
      userType: this.userData.userType,
      password: '',
      confirmPassword: '',
      edpNo: this.userData.edpNo,
      emailId: this.userData.emailId,
      firstName: this.userData.fname,
      lastName: this.userData.lname,
      changPasswdFirstLogin: 0,
      changePasswdAllowed: this.userData.changepass,
      internalUser: this.userData.fintuser,
      arUser: this.userData.arUser,
      allowNotes: this.userData.fallownotes
    });
  }

}
